import Layout from "components/layout";
import { SigninUp } from "features/user/components/SigninUp";
import { GetServerSideProps, GetServerSidePropsContext } from "next";
import { NextSeoProps, NextSeo } from "next-seo";
import { ReactNode } from "react";
import { MetaTag } from "utils/seo";
import { getServerSidePropsWithoutAuth } from "utils/ssr";
import getNextSeoProps from "utils/ssr/getNextSeoProps";

interface Props {
  nextSeoProps: NextSeoProps;
}

const SigninUpPage = ({ nextSeoProps }: Props) => {
  return (
    <>
      <NextSeo {...nextSeoProps} />
      <SigninUp />
    </>
  );
};

SigninUpPage.getLayout = (page: ReactNode) => {
  return (
    <Layout nav={null} footer={null}>
      {page}
    </Layout>
  );
};

export const getServerSideProps: GetServerSideProps = async (
  ctx: GetServerSidePropsContext
) => {
  const nextSeoProps = getNextSeoProps(ctx, {
    title: MetaTag.signIn.title,
    description: MetaTag.signIn.description,
  });

  return getServerSidePropsWithoutAuth(ctx, { props: { nextSeoProps } });
};

export default SigninUpPage;
